"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import * as Icon from "@phosphor-icons/react/dist/ssr";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import useMenuMobile from "@/store/useMenuMobile";
import { menus } from "@/lib/menu";
import GetInstantQuoteButton from "@/components/Contact/GetInstantQuote";
import { useModalInquiryContext } from "@/context/ModalInquiryContext";
import { CloudUploadOutlined, DownOutlined, RightOutlined } from "@ant-design/icons";
import { useCategory } from "@/context/CategoriesContext";
import { filterCateImg } from "@/components/Home2/Collection";
import { getBlogCls } from "@/lib/api/blog";
import { Blog } from "@/lib/@types/api/blog";
import { defaultLocale } from "@/config";
import CategoriesMenuTwo from "@/components/Header/Menu/CategoriesMenuTwo.tsx";
import FlagIcon from "../../Flag/index";
import { SITE_LOCALES } from "@/lib/constant";
import { type TLocale } from "@/lib/@types/locale";
import { usePathname } from "next/navigation";
import Translate from "@/components/Translate/index";
import Search from "./search";
import InquiryBtn from "./InquiryBtn";
import CartDrawer from "@/components/Product/ShoppingCart/cartDrawer";
import CountBadge from "@/components/Badge/count-badge";
import { useShoppingCartStore } from "@/lib/store/shoppingCart";
import NavUser from "@/components/User/nav-user";
import clsx from "clsx";
import { useLoveStore } from "@/lib/store/love.store";

const MenuTwo = ({ locale }: { locale: string }) => {
	const router = useRouter();

	const t = useTranslations();
	const { openModalInquiry } = useModalInquiryContext();
	const { openMenuMobile, handleMenuMobile } = useMenuMobile();
	const [fixedHeader, setFixedHeader] = useState(false);
	const [lastScrollPosition, setLastScrollPosition] = useState(0);
	const [isTransparent, setIsTransparent] = useState(true);
	const { categories } = useCategory();
	const { loveIds } = useLoveStore();
	const [loveCount, setLoveCount] = useState(0);
	const [blogCls, setBlogCls] = useState<Blog.BlogCl[]>([]);
	const [showService, setShowService] = useState(false);
	const [showChildrenID, setShowChildrenID] = useState(-1);
	const [showGrandChildIndex, setShowGrandChildIndex] = useState(-1);
	const [isOpenLanguage, setIsOpenLanguage] = useState(false);
	const [currentSlug, setCurrentSlug] = useState("");
	const currentLocales: TLocale[] = SITE_LOCALES;
	const [count, setCount] = useState(0);
	const pathname = usePathname(); // 当前路径，例如 /en/blog/123
	const { cartList } = useShoppingCartStore();

	useEffect(() => {
		getBlogCls({ lang_code: { lang_code: locale } }).then((res) => {
			if (res) {
				setBlogCls(res);
			}
		});
	}, []);
	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			setFixedHeader(scrollPosition > 0 && scrollPosition < lastScrollPosition);
			setLastScrollPosition(scrollPosition);
			setIsTransparent(scrollPosition <= 40);
		};
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [lastScrollPosition]);
	useEffect(() => {
		setCount(cartList?.lines?.length || 0);
	}, [cartList]);
	useEffect(() => {
		if (pathname) {
			if (locale === defaultLocale) {
				setCurrentSlug(pathname);
			} else {
				setCurrentSlug(pathname.replace(locale, ""));
			}
		}
	}, [pathname]);
	useEffect(() => {
		setLoveCount(() => {
			return loveIds.length > 99 ? 99 : loveIds.length;
		});
	}, [loveIds]);

	const setMenuShow = (id: number) => {
		if (id === 2) {
			setShowService(!showService);
		} else {
			if (showChildrenID === id) {
				setShowChildrenID(-1);
			} else {
				setShowChildrenID(id);
			}
		}
	};
	const setgs = (index: number) => {
		if (showGrandChildIndex === index) {
			setShowGrandChildIndex(-1);
		} else {
			setShowGrandChildIndex(index);
		}
	};
	const GoToPage = (url: string) => {
		router.push(url);
		handleMenuMobile();
	};
	const getFlag = (code: string) => {
		return SITE_LOCALES.find((item) => {
			return item.code === code;
		})!.flag;
	};

	return (
		<>
			<header
				className={`header-menu style-one fixed h-[65px] w-full transition-all duration-300 ${
					isTransparent ? "border-b-[0.5px] border-black bg-transparent !shadow-none" : " bg-white"
				}`}
			>
				<div className="container mx-auto h-full">
					<div className="header-main flex h-full justify-between">
						<div className="menu-mobile-icon flex items-center lg:hidden" onClick={handleMenuMobile}>
							<i className="icon-category text-2xl"></i>
						</div>

						<Link href={"/"} className=" flex items-center !text-black max-md:ml-0 max-md:pl-[80px]  ">
							<div className="heading4 flex  h-full items-center">
								<Image
									src="/image/logo.png"
									width={80}
									height={60}
									alt="STARY-logo"
									className=" object-cover "
								></Image>
							</div>
							<h1 className="text-button-uppercase ml-2 hidden text-xl font-bold">STARY</h1>
						</Link>

						<nav className="menu-main mr-[200px]  h-full max-lg:hidden">
							<ul className="flex h-full items-center gap-8  ">
								{menus.map((item) => {
									{
										return (
											item.show && (
												<li
													className={`group h-full ${item.id === 9 || item.id === 15 ? "relative" : ""}`}
													key={item.id}
												>
													{!item.hasSlug && item.id !== 15 ? (
														<div className="text-button-uppercase flex h-full  items-center justify-center text-black duration-300 ">
															{t(item.name)}
														</div>
													) : (
														<Link
															href={item.link}
															className="text-button-uppercase  font-poppins flex h-full  items-center justify-center !font-medium text-black duration-300"
														>
															{t(item.name)}
														</Link>
													)}
													{item.children && (
														<div className="sub-menu  absolute  -left-0   max-h-[500px]    overflow-y-auto  rounded-b-sm bg-gray-50">
															<ul>
																{item.children.map((child, index) => {
																	return (
																		<li key={index} className="w-full cursor-pointer  text-nowrap px-3 py-2">
																			<Link
																				href={child.link}
																				className="block font-bold text-black hover:!text-main"
																			>
																				{t(child.name)}
																			</Link>
																		</li>
																	);
																})}
															</ul>
														</div>
													)}
													{item.id === 2 && (
														// mega-menu
														<CategoriesMenuTwo locale={locale}></CategoriesMenuTwo>
													)}
												</li>
											)
										);
									}
								})}
							</ul>
						</nav>
						<div className="right flex items-center gap-2 max-md:mr-0 lg:mr-[40px] 2xl:mr-[200px]">
							<Search lastScrollPosition={1} className="max-md:!hidden" />
							<div>
								<li className="c-flex  ">
									<Link
										href={"/tourist-order-inquiry"}
										className="c-flex  relative h-[42px] w-[42px] rounded-full text-black hover:bg-[#F3F4F6] hover:!text-black max-md:pl-4"
									>
										<i className={clsx("ri-file-search-line text-2xl")}></i>
									</Link>
								</li>
							</div>
							<InquiryBtn lastScrollPosition={isTransparent ? 0 : 100} />
							{process.env.NEXT_PUBLIC_SITE_TYPE == "toc" && (
								<li className="c-flex cursor-pointer px-2 ">
									<CartDrawer>
										<div className="c-flex h-[42px] w-[42px] rounded-full text-black hover:bg-[#F3F4F6] max-md:!hidden">
											<i className={`ri-shopping-cart-2-line relative text-2xl  `}>
												<CountBadge count={count} />
											</i>
										</div>
									</CartDrawer>
								</li>
							)}
							<NavUser>
								<div className="c-flex h-[42px]  rounded-full ">
									<div
										className={`s-flex text-black" gap-x-2 
											 max-md:text-black 
										`}
									>
										<i className="ri-user-line text-2xl"></i>

										{/* <p className="">{user ? user.username : t("home.My Account")}</p> */}
										{/* <img className="w-[2rem] h-[2rem]" src="/image/home/icon/user.png" alt="user" /> */}
									</div>
								</div>
							</NavUser>
							<Translate lastScrollPosition={1}></Translate>
						</div>
					</div>
				</div>
			</header>
			<div id="menu-mobile" className={` ${openMenuMobile ? "open" : ""} `}>
				<div className="menu-container h-full bg-white">
					<div className="container h-full">
						<div className="menu-main h-full overflow-auto">
							<div className="heading relative flex items-center justify-center py-2">
								<div
									className="close-menu-mobile-btn bg-surface absolute left-0 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full"
									onClick={handleMenuMobile}
								>
									<Icon.X size={14} />
								</div>
								<div
									onClick={() => GoToPage("/")}
									className="logo text-button-uppercase text-center text-3xl font-semibold text-black"
								>
									STARRY
								</div>
							</div>
							<div className="list-nav mt-6">
								<ul>
									{menus.map((item) => {
										{
											return (
												item.show && (
													<li className="mb-5 h-full " key={item.id}>
														{!item.hasSlug ? (
															<div
																className="text-button-uppercase  flex justify-between !rounded-lg border p-2 text-black duration-300"
																onClick={() => setMenuShow(item.id)}
															>
																<span>{t(item.name)}</span>
																<RightOutlined />
															</div>
														) : (
															<div
																onClick={() => GoToPage(item.link)}
																className="text-button-uppercase  flex justify-between !rounded-lg border p-2 text-black duration-300"
															>
																<span>{t(item.name)}</span>
																<RightOutlined />
															</div>
														)}

														{item.id === 2 && showService && (
															<div className="transform pt-2 transition-all duration-500">
																{categories?.edges.map((item, index) => {
																	return (
																		<div key={item.node.id} className="my-1 rounded-lg pr-2 text-black ">
																			<div className="mb-1 flex items-center justify-between gap-x-2 rounded-md border border-gray-300 pr-2">
																				<div
																					className="flex w-fit items-center px-1"
																					onClick={() => GoToPage(`/${item.node.slug}`)}
																				>
																					<Image
																						src={
																							filterCateImg(item.node.metadata)[0]?.url ||
																							"/image/default-image.webp"
																						}
																						width={50}
																						quality={50}
																						height={50}
																						alt={item.node.name}
																						className="h-[40px] w-[40px] rounded object-cover"
																					/>
																					<div className="font-bold">
																						{locale === defaultLocale
																							? item.node.name
																							: item.node?.translation?.name || item.node.name}
																					</div>
																				</div>
																				<div
																					className="h-6 w-6 rounded-full bg-[#4296ec] text-center !text-white "
																					onClick={() => setgs(index)}
																				>
																					{showGrandChildIndex === index ? (
																						<DownOutlined />
																					) : (
																						<RightOutlined />
																					)}
																				</div>
																			</div>

																			{showGrandChildIndex === index && (
																				<div className={` ml-2 rounded-md border border-gray-300`}>
																					{item.node.children &&
																						item.node.children.edges.map((child) => {
																							return (
																								<div
																									key={child.node.slug}
																									className=" p-1 "
																									onClick={() => GoToPage(`/${child.node.slug}`)}
																								>
																									<div className="flex items-center p-1">
																										<Image
																											src={
																												filterCateImg(child.node.metadata)[0]?.url ||
																												"/image/default-image.webp"
																											}
																											width={50}
																											quality={50}
																											height={50}
																											alt={child.node.name}
																											className="rounded object-cover px-1"
																										/>
																										<div className="font-bold">
																											{locale === defaultLocale
																												? child.node.name
																												: child.node.translation.name || child.node.name}
																										</div>
																									</div>
																								</div>
																							);
																						})}
																				</div>
																			)}
																		</div>
																	);
																})}
															</div>
														)}
														{item.id === showChildrenID && item.children && (
															<div className="transform pt-2 transition-all duration-500">
																<ul>
																	{item.children.map((child, index) => {
																		return (
																			<li
																				key={index}
																				className="w-full cursor-pointer  text-nowrap px-3 py-2"
																			>
																				<div
																					onClick={() => GoToPage(child.link)}
																					className="block font-bold text-black hover:!text-main"
																				>
																					{t(child.name)}
																				</div>
																			</li>
																		);
																	})}
																</ul>
															</div>
														)}
													</li>
												)
											);
										}
									})}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default MenuTwo;
